/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\error.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


export const ADD_ERROR = 'ADD_ERROR_';
export const REMOVE_ERROR = 'REMOVE_ERROR_';
export const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS_';
export const MAIL_ERROR = 'MAIL_ERROR';
export const MAIL_ERROR_NOT = 'MAIL_ERROR_NOT';

export function raiseError(uiid, code, args = []) {
  return {
    type: ADD_ERROR,
    ui: uiid,
    code,
    args,
  };
}

export function removeError(uiid, code) {
  return {
    type: REMOVE_ERROR,
    ui: uiid,
    code,
  };
}

export function clearAllErrors() {
  return {
    type: CLEAR_ALL_ERRORS,
  };
}

export function raiseMailError() {
  return {
    type: MAIL_ERROR,
  };
}

export function unraiseMailErrors() {
  return {
    type: MAIL_ERROR_NOT,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/error.js